import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = logged
  const [org, setOrg] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const r = await api("/auth/me");
      setUser(r.user);
      setOrg(r.organization);
    } catch (e) {
      setUser(false);
      setOrg(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const r = await api("/auth/login", { method: "POST", body: { email, password } });
    setUser(r.user); setOrg(r.organization);
    return r;
  };
  const register = async (payload) => {
    const r = await api("/auth/register", { method: "POST", body: payload });
    setUser(r.user); setOrg(r.organization);
    return r;
  };
  const logout = async () => {
    try { await api("/auth/logout", { method: "POST" }); } catch (e) {}
    setUser(false); setOrg(null);
  };

  return (
    <AuthCtx.Provider value={{ user, org, setOrg, login, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
